export const MAX_IMAGE_FILE_SIZE = 20 * 1024 * 1024;
export const MAX_AUDIO_FILE_SIZE = 10 * 1024 * 1024;
export const MAX_MATERIAL_FILE_SIZE = 20 * 1024 * 1024;
export const MAX_GALLERY_COUNT = 30;
